module.exports = __webpack_public_path__ + "static/media/disable-badge.d90acce3.svg";